import * as gtag from "../utils/gtag";

export default class AnalyticsSender {
    sendClickLogoMenuEvent() {
        gtag.overallEvent('click_logo', 'unknown');
    }

    sendClickHowToMenuEvent() {
        gtag.overallEvent('click_howto_menu', 'unknown');
    }

    sendClickContactMenuEvent() {
        gtag.overallEvent('click_contact_menu', 'unknown');
    }

    sendClickLanguageMenuEvent(locale: string) {
        gtag.overallEvent('click_language_menu', locale);
    }

    sendHowToBtnClick() {
        gtag.overallEvent('click_upload', 'how-to');
    }

    sendDownloadBtnClick(requestId: string) {
        gtag.overallEvent('click_download', 'unknown', requestId);
    }

    sendUploadBtnClick(label: string) {
        gtag.overallEvent('click_upload', label);
    }

    sendClickRate(label: string, requestId: string) {
        gtag.overallEvent('click_rate', label, requestId);
    }

    sendAddDemoImg(label: string, requestId: string) {
        gtag.overallEvent('add_demo_image', label, requestId);
    }

    sendClickEmail() {
        gtag.overallEvent('click_email', 'unknown');
    }

    sendClickMenuTools(label: string) {
        gtag.overallEvent('click_menu_tools', label);
    }

    sendShowLandingPage() {
        gtag.overallEvent('show_landing_page', 'unknown');
    }

    sendShowUpload() {
        gtag.overallEvent('show_upload', 'unknown');
    }

    sendShowHowTo() {
        gtag.overallEvent('show_how_to_page', 'unknown');
    }

    sendHowToFullScroll(label: string) {
        gtag.overallEvent('full_scroll', label);
    }

    sendClickHowTo(label: string) {
        gtag.overallEvent('click_how_to', label);
    }

    sendAddImage(formatIn, widthIn, heightIn) {
        gtag.overallEvent('add_image', `${formatIn}|${widthIn}x${heightIn}`);
    }

    sendAddError(error: string) {
        gtag.overallEvent('add_error', error);
    }

    sendChangeDimensiom(width: number, height: number, changeDimension: string) {
        gtag.overallEvent('edit_width_height', `${changeDimension}|${width}x${height}`);
    }

    sendErrorChangeDimensiom(width: number, height: number, changeDimension: string) {
        gtag.overallEvent('edit_width_height_error', `${changeDimension}|${width}x${height}`);
    }

    sendChangeSelectFormat(format: string) {
        gtag.overallEvent('click_out_format', format);
    }

    sendShowRemovePopup() {
        gtag.overallEvent('show_popup_remove_image', 'unknown');
    }


    sendRemoveImage() {
        gtag.overallEvent('click_popup_remove_image', 'remove');
    }

    sendChangeSaveProporsion(isSave) {
        gtag.overallEvent('click_lock', isSave ? 'on' : 'off');
    }

    sendClickCategoryPreview(category = 'unknown') {
        gtag.overallEvent('click_cat_resize', category);
    }

    sendClickCategoryScroll() {
        gtag.overallEvent('click_scroll_cat_resize', 'unknown');
    }
    sendDownloadPreview(category, previewName, dimensions) {
        gtag.overallEvent('download_preview', `${category}|${previewName}|${dimensions}`);
    }

    sendEditPreview(category, previewName, dimensions) {
        gtag.overallEvent('edit_preview', `${category}|${previewName}|${dimensions}`);
    }

    sendChangePreview(category, previewName, dimensions) {
        gtag.overallEvent('edit_preview_drag', `${category}|${previewName}|${dimensions}`);
    }

    sendDownloadPopupUpdate(category, previewName, dimensions) {
        gtag.overallEvent('download_preview_popup', `${category}|${previewName}|${dimensions}`);
    }


    sendClosePopupUpdate(category, previewName, dimensions) {
        gtag.overallEvent('close_preview', `${category}|${previewName}|${dimensions}`);
    }
    
    sendSelectAllPreview(category) {
        gtag.overallEvent('click_select_all_preview', `${category}`);
    }


    sendDeSelectAllPreview(category) {
        gtag.overallEvent('click_deselect_all_preview', `${category}`);
    }
    
    sendDownloadSelectPreview(category, items) {
        gtag.overallEvent('download_preview_selected', `${category}|${items}`);
    }

    sendSelectPreview(category, previewName, dimensions) {
        gtag.overallEvent('click_select_preview', `${category}|${previewName}|${dimensions}`);
    }

    sendClickServiceToolResizer() {
        gtag.overallEvent('click_service_tool_resizer', `unknown`);
    }

    sendClickServiceToolRotater() {
        gtag.overallEvent('click_service_tool_rotator', `unknown`);
    }

    sendClickRotateRight() {
        gtag.overallEvent('click_rotate_right   ', `unknown`);
    }

    sendClickRotateLeft() {
        gtag.overallEvent('click_rotate_left', `unknown`);
    }

    sendErrorSizeImage() {
        gtag.overallEvent('add_error', `over12000px`);
    }

    sendScaleCropper(isChange:string, width: number, height:number) {
        gtag.overallEvent('scale_cropper', `${isChange}|${width}x${height}`);
    }

    sendClickResset() {
        gtag.overallEvent('click_reset', `unknown`);
    }

    sendClickCrop(originalWidth: number, originalHeight: number, cropWidth: number, cropHeight: number) {
        gtag.overallEvent('click_crop', `${originalWidth}x${originalHeight}|${cropWidth}x${cropHeight}`);
    }
}